<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 11.5H24.5M13 16H21M12 20.5H22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
